import { render, staticRenderFns } from "./DMIDResourcesAndTools.vue?vue&type=template&id=2187eeaf&scoped=true&"
import script from "./DMIDResourcesAndTools.vue?vue&type=script&lang=js&"
export * from "./DMIDResourcesAndTools.vue?vue&type=script&lang=js&"
import style0 from "./DMIDResourcesAndTools.vue?vue&type=style&index=0&id=2187eeaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187eeaf",
  null
  
)

export default component.exports